"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsAndroid = void 0;
const browser_1 = require("lepont/browser");
const shared_1 = require("./shared");
/**
 * Requests the permission.
 */
const request = (permission, rationale) => browser_1.sendMessage({
    type: shared_1.TYPE_REQUEST,
    payload: { permission, rationale },
});
/**
 * Checks the permission.
 */
const check = async (permission) => browser_1.sendMessage({
    type: shared_1.TYPE_CHECK,
    payload: { permission },
});
const requestMultiple = async (permissions) => browser_1.sendMessage({
    type: shared_1.TYPE_REQUEST_MULTIPLE,
    payload: { permissions },
});
exports.PermissionsAndroid = {
    PERMISSIONS: shared_1.PERMISSIONS,
    RESULTS: shared_1.RESULTS,
    request,
    check,
    requestMultiple,
};
